import logo from './logo.svg';
import './App.css';
import Card from './components/Card';

function App() {
  return (
    <div className="App">
      <h1>PremieraServiceBot</h1>
      <Card isPdf = {true} pdf = 'pdf1' title = "Инструкция по установке" text = "Этот документ описывает шаги для начальной настройки и развертывания Системы в демонстрационных целях"/>
      <Card isPdf = {true} pdf = 'pdf2' title = "Описание характеристик" text = "Этот документ представляет собой обзор основных модулей и функций Системы"/>
      <Card isPdf = {true} pdf = 'pdf3' title = "Правила эксплуатации" text = "В этом документе вы найдете всю необходимую информацию для работы с ПО"/>
      <Card isPdf = {true} pdf = 'pdf4' title = "Жизненный цикл" text = "Документ описывает процессы, которые поддерживают функционирование и обновление Системы"/>
      <Card isPdf = {false} pdf = 'pdf1' title = "Связаться с нами" text = "Отправьте нам сообщение по электронной почте. Кликните здесь, чтобы открыть вашу почтовую программу"/>
        <footer>ООО "Диджитал Скрипка" ИНН 6450117585 Адрес: 410031, г Саратов, ул им Некрасова Н.А., д. 33/35 </footer>
      </div>
  );
}

export default App;
